import React from 'react';

import { FeatureFlags } from '~src/commonInfra/featureFlags/FeatureFlags';
import { SessionManagementService } from '~src/sessionManagement/SessionManagementService';
import { Sites } from '~src/siteManagement/services/resources/Sites';

import { CredentialEncryptionSection } from './sections/credential-encryption/CredentialEncryptionSection';
import { ExtractEncryptionSection } from './sections/extract-encryption/ExtractEncryptionSection';
import { IpAllowlistSection } from './sections/ip-allowlist/IpAllowlistSection';
import { securitySiteSettingsSpaceContainer } from './styles/SecuritySiteSettingsStyles';

export interface SecuritySiteSettingsSubspaceProps {
    readonly server: SessionManagementService;
    readonly sites: Sites;
}

export class SecuritySiteSettingsSubspaceComponent extends React.PureComponent<SecuritySiteSettingsSubspaceProps, {}> {
    public constructor(props: SecuritySiteSettingsSubspaceProps) {
        super(props);
    }

    public render(): JSX.Element {
        return(
        <div className={securitySiteSettingsSpaceContainer}>
            {FeatureFlags.enableExternalKeyManagementEnabled ?
                <ExtractEncryptionSection siteId={this.props.server.sessionSiteId()}/> : null}
            {FeatureFlags.externalKeyManagementCredentialsEnabled?
                <CredentialEncryptionSection siteId={this.props.server.sessionSiteId()}/> : null}
            <IpAllowlistSection />
        </div>);
    }
}